import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    expandButton: {
      margin: 0,
      borderRadius: 0,
      alignSelf: 'stretch',
    },
    listItem: {
      padding: 0,
    },
    getLevelSx: (level: number) => {
      return { padding: theme.spacing(0, 0, 0, level) };
    },
  };
};
